import React from "react";
import { useSelector } from "react-redux";
import Preloader from "./Preloader";

const GlobalApiLoader = () => {
  const pending = useSelector((s) => s?.globalLoaderReducer?.pendingRequests || 0);
  if (!pending) return null;
  return <Preloader />;
};

export default GlobalApiLoader;

